export default __webpack_public_path__ + "static/screeny-150-storm-5-f8f42d1d06a660b4c9deffd8297d7bca.jpg";